import { render, staticRenderFns } from "./StockTallasComponent.vue?vue&type=template&id=f900466e"
import script from "./StockTallasComponent.vue?vue&type=script&lang=js"
export * from "./StockTallasComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports